import Icon from '../components/Icon.vue'

Icon.register({
  'chess-pawn': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M105.1 224c-29.4-18.4-49.1-50.8-49.1-88 0-57.4 46.6-104 104-104s104 46.6 104 104c0 37.2-19.7 69.6-49.1 88h25.1c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16v5.5c0 44 4.1 86.6 24 122.5h-176c19.9-35.9 24-78.5 24-122.5v-5.5h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h25.1zM304 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-pawn.js
// module id = 1181
// module chunks = 0